var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Mesh, MeshBasicMaterial, DoubleSide, MeshPhongMaterial } from "three";
import { PreloadableMeshProviderBase } from "./PreloadableMeshProviderBase";
import { createWireframeMaterial, addBarycentricCoordinates } from "../rendering/shader/BarycentricWireframe";
export class MonitorMeshProvider extends PreloadableMeshProviderBase {
    constructor() {
        // super("meshes/heads/FlyingMonitor_A_07");
        super("meshes/heads/Monitor_framed");
    }
    getMonitorObject(connection) {
        return __awaiter(this, void 0, void 0, function* () {
            const mesh = yield this.getMesh(connection);
            this.sanityCheck(mesh);
            this.createNewMaterial(mesh);
            return mesh;
        });
    }
    /**
     * Each avatar can have a different attributes,
     * therefore a new material is needed for each mesh
     */
    createNewMaterial(mesh) {
        mesh.traverse((child) => {
            if (child instanceof Mesh) {
                if (child.name === "MonitorHull") {
                    addBarycentricCoordinates(child.geometry);
                    child.material = createWireframeMaterial();
                }
                else if (child.name === "MonitorScreen") {
                    child.material = new MeshBasicMaterial();
                }
                else if (child.name === "MonitorFrame") {
                    child.material = new MeshPhongMaterial();
                }
                else if (child.name.startsWith("Indicator")) {
                    const material = Array.isArray(child.material) ? child.material[0] : child.material;
                    if (material && "map" in material) {
                        child.material = new MeshBasicMaterial({
                            map: material.map,
                            transparent: true,
                            alphaTest: 0.1,
                            side: DoubleSide,
                            color: material.color
                        });
                    }
                }
            }
        });
    }
    sanityCheck(mesh) {
        let hasIndicatorMuted = false;
        let hasIndicatorVolume = false;
        let hasScreen = false;
        let hasFrame = false;
        mesh.traverse((child) => {
            if (child instanceof Mesh) {
                if (child.name === "MonitorScreen") {
                    hasScreen = true;
                }
                else if (child.name === "MonitorFrame") {
                    hasFrame = true;
                }
                else if (child.name === "IndicatorMuted") {
                    hasIndicatorMuted = true;
                }
                else if (child.name === "IndicatorVolume") {
                    hasIndicatorVolume = true;
                }
            }
        });
        if (!hasIndicatorMuted)
            throw new Error("HeadMonitor-Mesh has no muted-indicator submesh.");
        if (!hasIndicatorVolume)
            throw new Error("HeadMonitor-Mesh has no volume-indicator submesh.");
        if (!hasScreen)
            throw new Error("HeadMonitor-Mesh has no screen submesh to show video transmission.");
        if (!hasFrame)
            throw new Error("HeadMonitor-Mesh has no frame-submes to show selected color.");
    }
}
